<template>
    <div class="vertical grow gallery-container" style="height: 100%">
        <!-- HerdIdentifier -->
        <div class="info-field horizontal">
            <tr class="info-field-row">
                <td class="title-td" style="width: 200px">
                    <p class="info-field-title">{{ $t("HerdIdentifier") }}</p>
                </td>
                <td style="width: 400px" class="info-field-value">
                    <input
                        class="datalist-input"
                        id="product-select-input"
                        style="width: 100%"
                        v-model="localSystem.herdIdentifier"
                    />
                </td>
            </tr>
        </div>
        <!-- ProducerNumber -->
        <div class="info-field horizontal">
            <tr class="info-field-row">
                <td class="title-td" style="width: 200px">
                    <p class="info-field-title">{{ $t("ProducerNumber") }}</p>
                </td>
                <td style="width: 400px" class="info-field-value">
                    <input
                        class="datalist-input"
                        id="product-select-input"
                        style="width: 100%"
                        v-model="localSystem.producerNumber"
                    />
                </td>
            </tr>
        </div>
        <!-- ClientId -->
        <div class="info-field horizontal">
            <tr class="info-field-row">
                <td class="title-td" style="width: 200px">
                    <p class="info-field-title">{{ $t("ClientId") }}</p>
                </td>
                <td style="width: 400px" class="info-field-value">
                    <input
                        class="datalist-input"
                        id="product-select-input"
                        style="width: 100%"
                        v-model="localSystem.clientId"
                    />
                </td>
            </tr>
        </div>
        <div style="align-self: center; margin-bottom: 20px">
            <div
                style="justify-content: center; margin-bottom: 10px"
                class="horizontal"
            >
                <div class="error" v-if="error != ''">{{ error }}</div>
            </div>
            <Button
                :title="$t('Save')"
                buttonClass="save-button semi-bold"
                style="width: 300px; align-self: center"
                @onClick="save"
            ></Button>
        </div>
    </div>
</template>

<script>
import { updateCloudSystemAssigment } from "../../api/api";
import Button from "../Button.vue";

export default {
    props: {
        selectedSystem: {
            type: Object,
        },
        server: {
            type: Object,
            required: true,
        },
    },
    components: {
        Button,
    },
    watch: {
        selectedSystem: {
            handler: function (newVal, oldVal) {
                console.log(newVal, oldVal);
                if (newVal == null) {
                    this.localSystem = {
                        herdIdentifier: null,
                        producerNumber: null,
                        clientId: null,
                        systemId: null,
                    };
                } else {
                    this.localSystem = {
                        herdIdentifier: newVal.herdIdentifier,
                        producerNumber: newVal.producerNumber,
                        clientId: newVal.clientId,
                        systemId: newVal.id,
                    };
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        async save() {
            this.error = "";

            if (this.localSystem.herdIdentifier == "") {
                this.error = "Herd Identifier required";
                return;
            }

            if (this.localSystem.producerNumber == "") {
                this.error = "Producer Number required";
                return;
            }

            console.log(this.localSystem);

            try {
                await updateCloudSystemAssigment(
                    this.server.id,
                    this.localSystem
                );

                this.$emit("save", true);
            } catch (ex) {
                alert(ex);
            }
        },
    },
    data() {
        return {
            localSystem: {
                herdIdentifier: null,
                producerNumber: null,
                clientId: null,
            },
            error: "",
        };
    },
    async mounted() {
        console.log(this.selectedSystem);
        console.log(this.localSystem);
    },
};
</script>

<style scoped>
.gallery-container {
    background: #f9f9f9;
    box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
    border-radius: 5px;
}

.section-title {
    font-weight: bold;
    text-align: center;
}

.info-field {
    border-bottom: 1px solid #e9e9e9;
    margin-bottom: 12px;
    margin-top: 12px;
    justify-content: center;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
    margin: 0;
}

.info-field-row {
    align-self: center;
    width: 80%;
    margin: 0;
    padding-bottom: 5px;
}

.section-title {
    font-weight: bold;
}

select,
input.datalist-input,
input.version-input {
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

.version-input {
    height: 25px;
    margin: 0 10px;
    width: 100px !important;
}

textarea {
    height: 200px;
    max-height: 300px;
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

.info-field-row > td {
    vertical-align: middle;
}

.error {
    font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/Cloud/EditCloudSystem.vue